import styled from 'src/styles'

import { StepState } from './types'

export const StyledStepper = styled.div`
  display: flex;
  align-items: center;
`

export const Step = styled.div<{ state: StepState }>`
  font-family: ${(props) => props.theme.typography.fontFamily};

  font-size: ${(props) => props.theme.typography.subheadlineMedium.fontSize};
  font-weight: ${(props) =>
    props.theme.typography.subheadlineMedium.fontWeight};
  line-height: ${(props) =>
    props.theme.typography.subheadlineMedium.lineHeight};
  letter-spacing: ${(props) =>
    props.theme.typography.subheadlineMedium.letterSpacing};

  display: flex;
  justify-content: center;
  align-items: center;

  width: 24px;
  height: 24px;

  border-radius: 50%;

  background-color: ${(props) =>
    props.state === StepState.Inactive
      ? props.theme.palette.fill.secondary
      : props.theme.palette.accent.base};
`

export const StepDivider = styled.div`
  background-color: ${(props) => props.theme.palette.fill.secondary};

  width: 44px;
  height: 2px;

  margin: 0 4px;
`
